module.exports = __webpack_public_path__ + "img/FR30077.7597f017.png";